// extracted by mini-css-extract-plugin
export default {"actionButton":"_11gAI","primaryActionMargin":"_1PAg7"};